import type { BadgeProps } from './Badge.typed';
import * as Styled from './Badge.styled';

export const Badge = (props: BadgeProps) => {
  const { children, style, ...rest } = props;
  return (
    <Styled.Badge style={style} {...rest}>
      {children}
    </Styled.Badge>
  );
};

export default Badge;
